var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBankStatus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 190,
    height: 190,
    viewBox: "0 0 190 190",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Image"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000002990"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.31492 137.189L88.3193 182.802C92.7392 185.352 99.9041 185.352 104.324 182.802L178.597 139.92C183.017 137.37 183.017 133.229 178.597 130.68L99.5924 85.0665C95.1725 82.5169 88.0076 82.5169 83.5877 85.0665L9.31492 127.949C4.89503 130.498 4.89503 134.634 9.31492 137.189Z",
    fill: "#E2E0E4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.5,
    d: "M181.912 128.317V122.944L177.613 123.153L99.59 78.1075C95.1702 75.5579 88.0053 75.5579 83.5854 78.1075L10.0384 120.571L6 120.203V125.624C6.00465 127.294 7.1073 128.96 9.31259 130.234L88.317 175.848C92.7369 178.397 99.9018 178.397 104.322 175.848L178.594 132.965C180.818 131.681 181.921 130.002 181.912 128.317Z",
    fill: "#1C359F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.31492 124.841L88.3193 170.454C92.7392 173.004 99.9041 173.004 104.324 170.454L178.597 127.572C183.017 125.022 183.017 120.882 178.597 118.332L99.5924 72.7188C95.1725 70.1692 88.0076 70.1692 83.5877 72.7188L9.31492 115.601C4.89503 118.151 4.89503 122.287 9.31492 124.841Z",
    fill: "#CEDAE3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M92.1403 141.262C91.9449 141.262 91.7495 141.262 91.5541 141.257C82.8353 141.169 74.7027 139.117 68.659 135.479C62.648 131.864 59.3866 127.081 59.4703 122.019C59.5122 119.474 60.3962 117.004 62.0943 114.673C63.839 112.281 66.37 110.151 69.6175 108.341C75.917 104.828 84.1891 102.944 92.9033 103.032C101.622 103.121 109.755 105.172 115.798 108.811C121.809 112.426 125.071 117.208 124.987 122.27C124.945 124.815 124.061 127.286 122.363 129.617C120.618 132.008 118.087 134.139 114.84 135.949C108.685 139.382 100.645 141.262 92.1403 141.262ZM92.3357 103.702C84.2822 103.702 76.2054 105.438 69.9478 108.927C63.7088 112.407 60.2287 117.06 60.1449 122.033C60.0658 126.844 63.2109 131.417 69.008 134.907C81.2953 142.3 101.711 142.509 114.519 135.363C120.758 131.883 124.238 127.23 124.322 122.256C124.401 117.446 121.256 112.872 115.459 109.383C109.173 105.605 100.766 103.702 92.3357 103.702Z",
    fill: "#1C359F"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M64.3299 129.288C64.3299 130.54 63.3157 131.558 62.0595 131.558C60.808 131.558 59.7891 130.544 59.7891 129.288C59.7891 128.036 60.8033 127.018 62.0595 127.018C63.3157 127.018 64.3299 128.036 64.3299 129.288Z",
    fill: "#1C359F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M124.535 115.141C124.535 116.253 123.633 117.151 122.526 117.151C121.414 117.151 120.516 116.248 120.516 115.141C120.516 114.033 121.418 113.131 122.526 113.131C123.633 113.126 124.535 114.029 124.535 115.141Z",
    fill: "#1C359F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M77.5929 141.275C78.2768 141.275 78.9049 141.121 79.3981 140.837L111.566 122.264C112.259 121.864 112.654 121.222 112.659 120.506C112.659 119.729 112.189 119.012 111.37 118.538L109.3 117.342C108.686 116.988 107.913 116.793 107.132 116.793C106.448 116.793 105.82 116.947 105.327 117.23L73.159 135.803C72.4658 136.203 72.0657 136.845 72.0704 137.562C72.0704 138.339 72.5403 139.055 73.3591 139.53L75.4295 140.726C76.0436 141.079 76.8113 141.275 77.5929 141.275Z",
    fill: "url(#paint0_linear_797_232748)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M112.229 72.403L107.599 69.7324C98.8387 76.4041 94.912 78.535 90.9806 79.5911C87.0492 83.0712 80.331 87.0863 71.5703 90.5292V109.53C71.5703 117.197 74.5944 121.045 78.1676 122.915L82.7922 125.586L82.5363 124.33C86.3002 124.944 90.976 125.018 90.976 125.018C90.9806 125.014 107.595 107.436 107.595 88.7287V77.5626L112.229 72.403Z",
    fill: "#DD9700"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M71.5703 90.5306L76.1996 93.2012L87.5098 91.2983L95.6099 82.2584L90.9806 79.5879C87.0492 83.0726 80.331 87.0877 71.5703 90.5306Z",
    fill: "#FFD33B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M111.714 72.1106L107.588 69.7285C98.8269 76.4002 94.9001 78.5311 90.9688 79.5872L95.598 82.2577L105.513 82.2391L112.217 72.3944L111.714 72.1106Z",
    fill: "#FFE359"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M95.6134 82.2676C91.682 85.7477 84.9638 89.7628 76.2031 93.2057V112.211C76.2031 130.919 95.6088 127.699 95.6134 127.699C95.6181 127.695 112.232 110.118 112.232 91.4098V72.4043C103.472 79.076 99.5448 81.2069 95.6134 82.2676Z",
    fill: "#FFAF19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M95.7063 125.234C94.1617 125.43 91.1236 125.621 88.1274 124.718C82.7072 123.08 78.4688 117.879 78.4688 110.942V95.1652C79.7435 94.5464 80.9951 93.8858 82.214 93.1832C87.4062 90.1824 92.7939 87.6979 95.7063 85.1251C98.6188 84.3341 101.024 82.3243 106.216 79.3234C107.431 78.6209 108.682 77.8392 109.962 76.9785V92.7552C109.962 99.6921 108.701 108.067 103.285 115.962C100.289 120.326 97.2463 123.648 95.7063 125.234Z",
    fill: "#FFAF19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M88.1274 124.716C82.7072 123.083 78.4688 117.877 78.4688 110.94V95.1632C79.7435 94.5444 80.9951 93.8837 82.214 93.1812C87.4062 90.1803 92.7939 87.6959 95.7063 85.123V125.232C94.1617 125.428 91.1236 125.619 88.1274 124.716Z",
    fill: "#FFAF19"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M102.16 96.9435C101.829 99.8141 100.773 103.001 99.0005 106.086C97.2279 109.17 95.004 111.678 92.701 113.395L89.5466 118.88L86.234 116.968C81.8699 114.418 81.8699 106.193 86.234 98.5998C90.598 91.0069 97.6745 86.922 102.043 89.4716L105.356 91.3838L102.16 96.9435Z",
    fill: "#00A658"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M89.5465 100.51C85.1824 108.103 85.1824 116.324 89.5465 118.878C93.9105 121.428 100.987 117.343 105.356 109.75C109.72 102.157 109.72 93.936 105.356 91.3817C100.987 88.8321 93.9105 92.9171 89.5465 100.51Z",
    fill: "#00D158"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M94.5349 112.857L95.6468 113.504C95.5956 113.476 95.5491 113.444 95.5026 113.406L94.3906 112.76C94.4372 112.792 94.4883 112.825 94.5349 112.857Z",
    fill: "#C6C0D0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M105.356 98.0385L104.244 97.3918C103.862 97.1685 103.36 97.2383 102.857 97.5267C102.392 97.7966 101.927 98.2525 101.555 98.8527L102.667 99.4994C103.039 98.8992 103.504 98.4433 103.969 98.1734C104.472 97.885 104.974 97.8199 105.356 98.0385Z",
    fill: "#D3E1FC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M102.677 99.5002L101.565 98.8535L96.3359 107.302L97.4479 107.949L102.677 99.5002Z",
    fill: "#D3E1FC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M92.3307 110.824L91.2188 110.178L94.3825 112.755L95.4944 113.402L92.3307 110.824Z",
    fill: "#D3E1FC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M95.214 106.153L94.102 105.507C93.7205 105.288 93.2181 105.353 92.7109 105.646L93.8229 106.293C94.33 106 94.8325 105.935 95.214 106.153Z",
    fill: "#D3E1FC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M93.8219 106.289L92.71 105.643C92.2726 105.894 91.8353 106.313 91.4724 106.866C90.6396 108.136 90.5279 109.616 91.2165 110.174L92.3285 110.821C91.6399 110.263 91.7515 108.783 92.5843 107.513C92.9472 106.959 93.3846 106.541 93.8219 106.289Z",
    fill: "#D3E1FC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M93.8428 106.291C93.4054 106.543 92.9681 106.961 92.6052 107.515C91.7724 108.785 91.6607 110.265 92.3493 110.823L95.513 113.4C95.9736 113.773 96.6296 113.721 97.2903 113.34C97.8346 113.024 98.3836 112.488 98.821 111.777L105.293 101.327C106.093 100.038 106.153 98.5821 105.432 98.0796C105.046 97.8098 104.511 97.8656 103.976 98.1727C103.511 98.4425 103.045 98.8985 102.673 99.4987L97.4438 107.943L95.3455 106.231C94.964 105.924 94.4057 105.966 93.8428 106.291Z",
    fill: "white"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M174.217 25.5968L174.868 25.9783C174.84 25.9597 174.812 25.9411 174.784 25.9225L174.133 25.541C174.156 25.5596 174.184 25.5829 174.217 25.5968Z",
    fill: "#1C359F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M180.354 17.2394L179.702 16.8579C179.479 16.7277 179.181 16.7695 178.888 16.937C178.614 17.0952 178.344 17.3651 178.125 17.714L178.776 18.0955C178.995 17.7419 179.27 17.4767 179.539 17.3185C179.832 17.1464 180.13 17.1092 180.354 17.2394Z",
    fill: "#1C359F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M178.763 18.0956L178.107 17.7188L175.25 22.3341L175.901 22.7156L178.763 18.0956Z",
    fill: "#1C359F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M173.229 24.6452L172.578 24.2637L174.141 25.5385L174.793 25.9153L173.229 24.6452Z",
    fill: "#1C359F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M174.916 21.9029L174.264 21.5214C174.041 21.3911 173.743 21.4283 173.445 21.6005L174.097 21.982C174.394 21.8145 174.692 21.7726 174.916 21.9029Z",
    fill: "#1C359F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M174.104 21.985L173.453 21.6035C173.197 21.7524 172.941 21.999 172.727 22.3247C172.238 23.0691 172.173 23.9391 172.578 24.2648L173.229 24.6463C172.824 24.3206 172.89 23.4506 173.378 22.7062C173.592 22.3758 173.848 22.1293 174.104 21.985Z",
    fill: "#1C359F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M174.085 21.9853C173.829 22.1341 173.574 22.3807 173.36 22.7064C172.871 23.4508 172.806 24.3208 173.211 24.6465L174.774 25.9213C175.044 26.14 175.43 26.1074 175.816 25.8841C176.137 25.698 176.458 25.3816 176.714 24.9675L180.301 19.1751C180.771 18.4168 180.808 17.5654 180.385 17.2676C180.157 17.1094 179.845 17.142 179.529 17.3234C179.254 17.4816 178.984 17.7515 178.766 18.1004L175.904 22.7204L174.969 21.9573C174.746 21.7666 174.416 21.7945 174.085 21.9853Z",
    fill: "#1C359F"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    opacity: 0.76
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M174.224 34.2804L174.876 34.6619C174.848 34.6433 174.82 34.6247 174.792 34.6061L174.141 34.2246C174.164 34.2432 174.192 34.2618 174.224 34.2804Z",
    fill: "#1C359F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M180.369 25.925L179.718 25.5435C179.495 25.4132 179.197 25.4551 178.904 25.6226C178.629 25.7808 178.359 26.0506 178.141 26.3995L178.792 26.781C179.011 26.4274 179.285 26.1623 179.555 26.0041C179.848 25.8319 180.146 25.7947 180.369 25.925Z",
    fill: "#1C359F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M178.794 26.7811L178.138 26.4043L175.281 31.0196L175.933 31.4011L178.794 26.7811Z",
    fill: "#1C359F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M173.237 33.328L172.586 32.9512L174.149 34.226L174.801 34.6028L173.237 33.328Z",
    fill: "#1C359F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M174.923 30.5865L174.272 30.205C174.049 30.0747 173.751 30.1119 173.453 30.2841L174.104 30.6656C174.402 30.4981 174.7 30.4562 174.923 30.5865Z",
    fill: "#1C359F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M174.104 30.6725L173.453 30.291C173.197 30.4399 172.941 30.6865 172.727 31.0122C172.238 31.7566 172.173 32.6266 172.578 32.9523L173.229 33.3338C172.824 33.0081 172.89 32.1381 173.378 31.3937C173.592 31.0633 173.848 30.8168 174.104 30.6725Z",
    fill: "#1C359F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M174.101 30.6708C173.845 30.8197 173.589 31.0663 173.375 31.3919C172.887 32.1364 172.822 33.0064 173.226 33.332L174.79 34.6068C175.059 34.8255 175.446 34.7929 175.832 34.5696C176.153 34.3835 176.474 34.0671 176.73 33.6531L180.317 27.8607C180.787 27.1023 180.824 26.2509 180.4 25.9532C180.172 25.795 179.861 25.8275 179.544 26.009C179.27 26.1672 179 26.437 178.781 26.786L175.92 31.4059L174.985 30.6429C174.762 30.4521 174.431 30.4801 174.101 30.6708Z",
    fill: "#1C359F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    opacity: 0.52
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M174.224 42.964L174.876 43.3455C174.848 43.3269 174.82 43.3083 174.792 43.2897L174.141 42.9082C174.164 42.9268 174.192 42.9454 174.224 42.964Z",
    fill: "#1C359F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M180.369 34.6047L179.718 34.2232C179.495 34.0929 179.197 34.1348 178.904 34.3023C178.629 34.4604 178.359 34.7303 178.141 35.0792L178.792 35.4607C179.011 35.1071 179.285 34.8419 179.555 34.6838C179.848 34.5163 180.146 34.479 180.369 34.6047Z",
    fill: "#1C359F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M178.794 35.4655L178.138 35.084L175.281 39.7039L175.933 40.0854L178.794 35.4655Z",
    fill: "#1C359F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M173.237 42.0116L172.586 41.6348L174.149 42.9049L174.801 43.2864L173.237 42.0116Z",
    fill: "#1C359F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M174.923 39.272L174.272 38.8905C174.049 38.7603 173.751 38.7975 173.453 38.9696L174.104 39.3511C174.402 39.179 174.7 39.1418 174.923 39.272Z",
    fill: "#1C359F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M174.104 39.3522L173.453 38.9707C173.197 39.1196 172.941 39.3662 172.727 39.6918C172.238 40.4362 172.173 41.3063 172.578 41.6319L173.229 42.0135C172.824 41.6878 172.89 40.8178 173.378 40.0734C173.592 39.7477 173.848 39.5011 174.104 39.3522Z",
    fill: "#1C359F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M174.101 39.3505C173.845 39.4994 173.589 39.746 173.375 40.0716C172.887 40.816 172.822 41.6861 173.226 42.0117L174.79 43.2865C175.059 43.5052 175.446 43.4726 175.832 43.2493C176.153 43.0632 176.474 42.7468 176.73 42.3328L180.317 36.5404C180.787 35.782 180.824 34.9306 180.4 34.6328C180.172 34.4747 179.861 34.5072 179.544 34.6887C179.27 34.8469 179 35.1167 178.781 35.4656L175.92 40.0856L174.985 39.3226C174.762 39.1365 174.431 39.1597 174.101 39.3505Z",
    fill: "#1C359F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    opacity: 0.28
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M174.224 51.6554L174.876 52.0369C174.848 52.0183 174.82 51.9997 174.792 51.9811L174.141 51.5996C174.164 51.6182 174.192 51.6368 174.224 51.6554Z",
    fill: "#1C359F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_31"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M180.361 43.2941L179.71 42.9126C179.487 42.7823 179.189 42.8242 178.896 42.9917C178.621 43.1499 178.351 43.4197 178.133 43.7687L178.784 44.1502C179.003 43.7966 179.277 43.5314 179.547 43.3732C179.84 43.2057 180.138 43.1638 180.361 43.2941Z",
    fill: "#1C359F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M178.77 44.153L178.114 43.7715L175.258 48.3914L175.909 48.7683L178.77 44.153Z",
    fill: "#1C359F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_33"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M173.237 50.7011L172.586 50.3242L174.149 51.5944L174.801 51.9759L173.237 50.7011Z",
    fill: "#1C359F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M174.923 47.9595L174.272 47.578C174.049 47.4478 173.751 47.485 173.453 47.6571L174.104 48.0386C174.402 47.8665 174.7 47.8293 174.923 47.9595Z",
    fill: "#1C359F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_35"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M174.112 48.0417L173.46 47.6602C173.204 47.809 172.949 48.0556 172.735 48.3813C172.246 49.1257 172.181 49.9957 172.586 50.3214L173.237 50.7029C172.832 50.3772 172.897 49.5072 173.386 48.7628C173.6 48.4371 173.856 48.1905 174.112 48.0417Z",
    fill: "#1C359F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_36"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M174.109 48.0399C173.853 48.1888 173.597 48.4354 173.383 48.7611C172.894 49.5055 172.829 50.3755 173.234 50.7012L174.797 51.976C175.067 52.1946 175.453 52.1621 175.839 51.9388C176.161 51.7527 176.482 51.4363 176.737 51.0222L180.325 45.2298C180.794 44.4715 180.832 43.6201 180.408 43.3223C180.18 43.1641 179.869 43.1967 179.552 43.3781C179.278 43.5363 179.008 43.8062 178.789 44.1551L175.928 48.775L174.993 48.012C174.769 47.8259 174.439 47.8492 174.109 48.0399Z",
    fill: "#1C359F"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_37"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    d: "M40.865 17.8156L41.5164 18.1971C41.4884 18.1785 41.4605 18.1599 41.4326 18.1413L40.7812 17.7598C40.8045 17.7784 40.8324 17.8016 40.865 17.8156Z",
    fill: "#1C359F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    d: "M47.002 9.45818L46.3506 9.07667C46.1273 8.9464 45.8296 8.98828 45.5365 9.15577C45.262 9.31395 44.9921 9.5838 44.7734 9.93274L45.4248 10.3142C45.6435 9.96065 45.918 9.69546 46.1878 9.53727C46.4809 9.36513 46.7787 9.32791 47.002 9.45818Z",
    fill: "#1C359F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    d: "M45.4111 10.3144L44.7551 9.9375L41.8984 14.5528L42.5498 14.9343L45.4111 10.3144Z",
    fill: "#1C359F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_42"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    d: "M39.8701 16.8678L39.2188 16.4863L40.782 17.7611L41.4333 18.138L39.8701 16.8678Z",
    fill: "#1C359F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_43"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_55",
    d: "M41.5639 14.1216L40.9126 13.7401C40.6893 13.6099 40.3915 13.6471 40.0938 13.8192L40.7451 14.2007C41.0429 14.0332 41.3406 13.9914 41.5639 14.1216Z",
    fill: "#1C359F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_56",
    d: "M40.7445 14.2057L40.0931 13.8242C39.8372 13.9731 39.5814 14.2197 39.3673 14.5454C38.8788 15.2898 38.8137 16.1598 39.2185 16.4855L39.8698 16.867C39.465 16.5413 39.5302 15.6713 40.0187 14.9269C40.2327 14.5965 40.4886 14.35 40.7445 14.2057Z",
    fill: "#1C359F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_45"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_57",
    d: "M40.7338 14.204C40.4779 14.3529 40.222 14.5995 40.008 14.9252C39.5195 15.6696 39.4543 16.5396 39.8591 16.8653L41.4223 18.14C41.6922 18.3587 42.0783 18.3261 42.4645 18.1028C42.7855 17.9167 43.1065 17.6004 43.3624 17.1863L46.9495 11.3939C47.4194 10.6355 47.4567 9.78412 47.0333 9.48636C46.8053 9.32817 46.4936 9.36074 46.1772 9.54219C45.9027 9.70038 45.6329 9.97022 45.4142 10.3192L42.5529 14.9391L41.6177 14.1761C41.3944 13.9853 41.0641 14.0133 40.7338 14.204Z",
    fill: "#1C359F"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_46",
    opacity: 0.76
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_58",
    d: "M40.865 26.5011L41.5164 26.8827C41.4884 26.864 41.4605 26.8454 41.4326 26.8268L40.7812 26.4453C40.8045 26.4639 40.8324 26.4825 40.865 26.5011Z",
    fill: "#1C359F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_59",
    d: "M47.0098 18.1457L46.3585 17.7642C46.1351 17.6339 45.8374 17.6758 45.5443 17.8433C45.2698 18.0015 44.9999 18.2713 44.7812 18.6202L45.4326 19.0017C45.6513 18.6482 45.9258 18.383 46.1956 18.2248C46.4887 18.0526 46.7865 18.0154 47.0098 18.1457Z",
    fill: "#1C359F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_60",
    d: "M45.4345 19.0019L44.7785 18.625L41.9219 23.2403L42.5732 23.6218L45.4345 19.0019Z",
    fill: "#1C359F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_61",
    d: "M39.8779 25.5487L39.2266 25.1719L40.7898 26.4467L41.4412 26.8235L39.8779 25.5487Z",
    fill: "#1C359F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_62",
    d: "M41.5639 22.8072L40.9126 22.4257C40.6893 22.2954 40.3915 22.3326 40.0938 22.5048L40.7451 22.8863C41.0429 22.7188 41.3406 22.6769 41.5639 22.8072Z",
    fill: "#1C359F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_63",
    d: "M40.7445 22.8932L40.0931 22.5117C39.8372 22.6606 39.5814 22.9072 39.3673 23.2329C38.8788 23.9773 38.8137 24.8473 39.2185 25.173L39.8698 25.5545C39.465 25.2288 39.5302 24.3588 40.0187 23.6144C40.2327 23.284 40.4886 23.0375 40.7445 22.8932Z",
    fill: "#1C359F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_64",
    d: "M40.7416 22.8915C40.4857 23.0404 40.2298 23.287 40.0158 23.6127C39.5273 24.3571 39.4621 25.2271 39.8669 25.5528L41.4301 26.8275C41.7 27.0462 42.0862 27.0136 42.4723 26.7903C42.7933 26.6042 43.1144 26.2878 43.3702 25.8738L46.9573 20.0814C47.4272 19.323 47.4645 18.4716 47.0411 18.1739C46.8131 18.0157 46.5014 18.0482 46.185 18.2297C45.9105 18.3879 45.6407 18.6577 45.422 19.0067L42.5607 23.6266L41.6256 22.8636C41.4022 22.6728 41.0719 22.7008 40.7416 22.8915Z",
    fill: "#1C359F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_47",
    opacity: 0.52
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_65",
    d: "M40.865 35.1847L41.5164 35.5662C41.4884 35.5476 41.4605 35.529 41.4326 35.5104L40.7812 35.1289C40.8045 35.1475 40.8324 35.1661 40.865 35.1847Z",
    fill: "#1C359F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_66",
    d: "M47.0098 26.8254L46.3585 26.4439C46.1351 26.3136 45.8374 26.3555 45.5443 26.523C45.2698 26.6811 44.9999 26.951 44.7812 27.2999L45.4326 27.6814C45.6513 27.3278 45.9258 27.0626 46.1956 26.9045C46.4887 26.737 46.7865 26.6997 47.0098 26.8254Z",
    fill: "#1C359F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_67",
    d: "M45.4345 27.6862L44.7785 27.3047L41.9219 31.9246L42.5732 32.3061L45.4345 27.6862Z",
    fill: "#1C359F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_68",
    d: "M39.8779 34.2323L39.2266 33.8555L40.7898 35.1256L41.4412 35.5071L39.8779 34.2323Z",
    fill: "#1C359F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_69",
    d: "M41.5639 31.4927L40.9126 31.1112C40.6893 30.981 40.3915 31.0182 40.0938 31.1903L40.7451 31.5718C41.0429 31.3997 41.3406 31.3625 41.5639 31.4927Z",
    fill: "#1C359F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_70",
    d: "M40.7445 31.5729L40.0931 31.1914C39.8372 31.3403 39.5814 31.5869 39.3673 31.9125C38.8788 32.657 38.8137 33.527 39.2185 33.8527L39.8698 34.2342C39.465 33.9085 39.5302 33.0385 40.0187 32.2941C40.2327 31.9684 40.4886 31.7218 40.7445 31.5729Z",
    fill: "#1C359F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_71",
    d: "M40.7416 31.5712C40.4857 31.7201 40.2298 31.9667 40.0158 32.2923C39.5273 33.0367 39.4621 33.9068 39.8669 34.2324L41.4301 35.5072C41.7 35.7259 42.0862 35.6933 42.4723 35.47C42.7933 35.2839 43.1144 34.9675 43.3702 34.5535L46.9573 28.7611C47.4272 28.0027 47.4645 27.1513 47.0411 26.8535C46.8131 26.6954 46.5014 26.7279 46.185 26.9094C45.9105 27.0676 45.6407 27.3374 45.422 27.6863L42.5607 32.3063L41.6256 31.5433C41.4022 31.3572 41.0719 31.3804 40.7416 31.5712Z",
    fill: "#1C359F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_48",
    opacity: 0.28
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_50"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_72",
    d: "M40.8728 43.8761L41.5242 44.2577C41.4963 44.239 41.4683 44.2204 41.4404 44.2018L40.7891 43.8203C40.8123 43.8389 40.8403 43.8575 40.8728 43.8761Z",
    fill: "#1C359F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_51"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_73",
    d: "M47.0098 35.5148L46.3585 35.1333C46.1351 35.003 45.8374 35.0449 45.5443 35.2124C45.2698 35.3706 44.9999 35.6404 44.7812 35.9894L45.4326 36.3709C45.6513 36.0173 45.9258 35.7521 46.1956 35.5939C46.4887 35.4264 46.7865 35.3845 47.0098 35.5148Z",
    fill: "#1C359F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_52"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_74",
    d: "M45.4189 36.3737L44.7629 35.9922L41.9062 40.6121L42.5576 40.989L45.4189 36.3737Z",
    fill: "#1C359F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_53"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_75",
    d: "M39.8779 42.9218L39.2266 42.5449L40.7898 43.8151L41.4412 44.1966L39.8779 42.9218Z",
    fill: "#1C359F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_54"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_76",
    d: "M41.5718 40.1802L40.9204 39.7987C40.6971 39.6685 40.3993 39.7057 40.1016 39.8778L40.7529 40.2593C41.0507 40.0872 41.3484 40.05 41.5718 40.1802Z",
    fill: "#1C359F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_55"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_77",
    d: "M40.7523 40.2585L40.1009 39.877C39.8451 40.0258 39.5892 40.2724 39.3752 40.5981C38.8866 41.3425 38.8215 42.2125 39.2263 42.5382L39.8776 42.9197C39.4729 42.594 39.538 41.724 40.0265 40.9796C40.2405 40.6539 40.4964 40.4073 40.7523 40.2585Z",
    fill: "#1C359F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_56"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_78",
    d: "M40.7494 40.2607C40.4935 40.4095 40.2376 40.6561 40.0236 40.9818C39.5351 41.7262 39.4699 42.5962 39.8747 42.9219L41.438 44.1967C41.7078 44.4154 42.094 44.3828 42.4801 44.1595C42.8011 43.9734 43.1222 43.657 43.3781 43.2429L46.9651 37.4505C47.435 36.6922 47.4723 35.8408 47.0489 35.543C46.8209 35.3848 46.5092 35.4174 46.1928 35.5988C45.9183 35.757 45.6485 36.0269 45.4298 36.3758L42.5685 40.9957L41.6334 40.2327C41.41 40.0466 41.0797 40.0699 40.7494 40.2607Z",
    fill: "#1C359F"
  })))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_797_232748",
    x1: 112.66,
    y1: 129.031,
    x2: 72.066,
    y2: 129.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2139,
    stopColor: "#F3F4F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7933,
    stopColor: "#E9EAED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E5E9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankStatus);
export default __webpack_public_path__ + "static/media/bank-status.e32c21f7fab2ba4374164cca21402c71.svg";
export { ForwardRef as ReactComponent };